let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jexs2")).then(() => parcelRequire('kS6aD'));